@if (recommendedUniversities$ | async; as recommendedUnis) {
	@if (recommendedUnis.length > 1) {
		<uc-recommended-unis-swiper
			ngSkipHydration
			[recommendedUnis]="recommendedUnis"
			[product]="product"
		/>
	}
	<!-- only 1 university -->
	@if (recommendedUnis.length === 1) {
		<uc-recommended-uni-single
			[uni]="recommendedUnis[0]"
			[componentName]="componentName"
			[product]="product"
		/>
	}
}
